import React from "react";

/* eslint-disable react/display-name */
export default React.memo(() => {
    return (
        <svg
            width="24"
            height="16"
            viewBox="0 0 24 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.4492 1.76494C23.6161 1.20861 23.4492 0.799805 22.6552 0.799805H20.0296C19.362 0.799805 19.0543 1.15295 18.8873 1.54236C18.8873 1.54236 17.5521 4.7969 15.6606 6.91094C15.0487 7.52289 14.7705 7.71759 14.4367 7.71759C14.2698 7.71759 14.0282 7.52289 14.0282 6.9666V1.76494C14.0282 1.09734 13.8345 0.799805 13.2781 0.799805H9.15212C8.73493 0.799805 8.48402 1.10965 8.48402 1.40331C8.48402 2.03619 9.42973 2.18214 9.52721 3.96242V7.82891C9.52721 8.67662 9.37411 8.83032 9.04031 8.83032C8.15022 8.83032 5.98506 5.56124 4.70093 1.82055C4.44927 1.0935 4.19685 0.799805 3.52582 0.799805H0.900217C0.150044 0.799805 0 1.15295 0 1.54236C0 2.2378 0.89014 5.68704 4.14463 10.2489C6.31428 13.3643 9.37117 15.0531 12.1528 15.0531C13.8218 15.0531 14.0282 14.678 14.0282 14.0319V11.6773C14.0282 10.9271 14.1864 10.7774 14.7149 10.7774C15.1043 10.7774 15.7719 10.9721 17.3296 12.4742C19.1099 14.2545 19.4034 15.0531 20.4047 15.0531H23.0303C23.7805 15.0531 24.1556 14.678 23.9392 13.9378C23.7024 13.2001 22.8524 12.1297 21.7246 10.8609C21.1126 10.1376 20.1947 9.35882 19.9165 8.96932C19.5271 8.46868 19.6384 8.2461 19.9165 7.80108C19.9165 7.80108 23.1154 3.29481 23.4492 1.76494Z"
                fill="white"
            />
        </svg>
    );
});